"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntitySelectOptionWithDescriptions = exports.EntitySelectOption = exports.EntitySelectOptionDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_value_1 = require("./entity-value");
var react_select_1 = require("react-select");
var html_1 = require("../elements/html");
var coalesce_1 = require("../../utils/coalesce");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var lodash_1 = require("lodash");
exports.EntitySelectOptionDefaultProps = {
  showDescription: false
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    padding: ", ";\n    flex-direction: column;\n  "], ["\n    display: flex;\n    padding: ", ";\n    flex-direction: column;\n  "])), theme_1.theme.UNIT(4))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-wrap: nowrap;\n    flex-shrink: 0;\n  "], ["\n    flex-wrap: nowrap;\n    flex-shrink: 0;\n  "])))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n    padding-top: ", ";\n  "], ["\n    font-size: ", ";\n    padding-top: ", ";\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Description: (0, styled_components_1.default)(html_1.HTML)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
var EntitySelectOption = function (props) {
  var className = props.className,
    data = props.data,
    selectProps = props.selectProps,
    showDescription = props.showDescription;
  var value = data.value,
    label = data.label,
    entity = data.entity;
  var inputValue = selectProps.inputValue;
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var select = defn.select;
  var badge = select.optionBadge(data);
  var description = (0, lodash_1.truncate)((0, coalesce_1.coalesce)(entity, ['description.text', 'description.plainTruncated', 'openGraph.description.text', 'openGraph.description.plainTruncated']), {
    length: 500
  });
  return /* @ts-ignore */react_1.default.createElement(react_select_1.components.Option, __assign({}, props), react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Value, {
    badge: badge,
    name: entity._optionLabel || entity.name,
    highlight: inputValue,
    entity: entity
  }), showDescription && description && react_1.default.createElement(My.Description, {
    text: description
  })));
};
exports.EntitySelectOption = EntitySelectOption;
var EntitySelectOptionWithDescriptions = function (props) {
  return react_1.default.createElement(exports.EntitySelectOption, __assign({}, props, {
    showDescription: true
  }));
};
exports.EntitySelectOptionWithDescriptions = EntitySelectOptionWithDescriptions;
exports.EntitySelectOption.defaultProps = exports.EntitySelectOptionDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;